module.exports = __webpack_public_path__ + "static/media/learning.fdc64450.gif";